const GTM_EVENTS = {
  CREATE_DOCUMENT_FROM_TEMPLATES: "Create Document From Template",
  ASSET_CREATE_DOCUMENT_CLICK: "Asset Create Document Click",
  ASSET_MY_DOCUMENTS_CLICK: "Asset My Documents Click",
  UPGRADE_CLICK: "Upgrade Click",
  ASSET_ALL_DOCUMENTS_CLICK: "Asset All Documents Click",
  TEMPLATE_LIBRARY_CLICK: "Template Library Click",
  CREATE_TEMPLATE_CLICK: "Create Template Click",
  TRUST_CENTER_CLICK: "Trust Center Click",
  TEMPLATEVIEW_SELECT_COVER_THEME_CLICK:
    "TemplateView Select cover theme click",
  TEMPLATEVIEW_CUSTOMIZE_COVER_THEME_CLICK:
    "TemplateView Customize cover theme click",
  TEMPLATEVIEW_LOCK_COVERPAGE_CLICK: "TemplateView Lock Coverpage Click",
  TEMPLATEVIEW_UNLOCK_COVERPAGE_CLICK: "TemplateView Unlock Coverpage Click",
  TEMPLATEVIEW_LOCK_UPGRADE_COVERPAGE_CLICK:
    "TemplateView Lock Upgrade Coverpage Click",
  TEMPLATEVIEW_DELETE_COVERPAGE_CLICK: "TemplateView Delete Coverpage Click",
  TEMPLATEVIEW_ADD_COVERPAGE_CLICK: "TemplateView Add Coverpage Click",
  DOCUMENTVIEW_DELETE_COVERPAGE_CLICK: "DocumentView Delete Coverpage Click",
  DOCUMENTVIEW_ADD_COVERPAGE_CLICK: "DocumentView Add Coverpage Click",
  TEMPLATEVIEW_BLOCKS_PANE_OPEN: "TemplateView Blocks Pane Open",
  TEMPLATEVIEW_SIGN_PANE_OPEN: "TemplateView Sign Pane Open",
  TEMPLATEVIEW_FORMFIELDS_PANE_OPEN: "TemplateView Form Fields Plane Open",
  TEMPLATEVIEW_METADATA_PANE_OPEN: "TemplateView Metadata Pane Open",
  TEMPLATEVIEW_SETTINGS_PANE_OPEN: "TemplateView Settings Pane Open",
  TEMPLATEVIEW_TEMPLATE_DETAILS_CLICK: "TemplateView Template Details Click",
  TEMPLATEVIEW_METAFIELDS_DETAILS_CLICK: "TemplateView Metafield Details Click",
  TEMPLATEVIEW_PREVIEW_TEMPLATE_CLICK: "TemplateView Preview Template Click",
  TEMPLATEVIEW_CLONE_TEMPLATE_CLICK: "TemplateView Clone Template Click",
  TEMPLATEVIEW_DOWNLOADJSON_SCHEMA_CLICK:
    "TemplateView Download Json Schema Click",
  TEMPLATEVIEW_PUBLISH_CLICK: "TemplateView Publish Click",
  TEMPLATEVIEW_DEEACTIVATE_TEMPLATE_CLICK:
    "TemplateView Deactivate Template Click",
  TEMPLATEVIEW_EDIT_TEMPLATE_CLICK: "TemplateView Edit Template Click",
  TEMPLATEVIEW_ACTIVATE_TEMPLATE_CLICK: "TemplateView Activate Template Click",
  TEMPLATEVIEW_CREATE_DOC_CLICK: "TemplateView Create Document Click",
  TEMPLATEVIEW_DROPDOWN_CREATE_DOC_CLICK:
    "TemplateView Dropdown Create Document Click",
  TEMPLATEVIEW_CREATE_BULKDOCS_CLICK:
    "TemplateView Create Bulk Documents Click",
  TEMPLATEVIEW_BACK_BUTTON_CLICK: "TemplateView Back button click",
  DOCUMENTVIEW_BLOCKS_PANE_OPEN: "DocumentView Blocks Pane Open",
  DOCUMENTVIEW_SIGN_PANE_OPEN: "DocumentView Sign Pane Open",
  DOCUMENTVIEW_NOTES_PANE_OPEN: "DocumentView Notes Pane Open",
  DOCUMENTVIEW_ATTACHMENT_PANE_OPEN: "DocumentView Attachment Pane Open",
  DOCUMENTVIEW_COLLABORATORS_PANE_OPEN: "DocumentView Collaborators Pane Open",
  DOCUMENTVIEW_ACTIVITY_PANE_OPEN: "DocumentView Activity Pane Open",
  DOCUMENTVIEW_METAFIELD_PANE_OPEN: "DocumentView Metafield Pane Open",
  DOCUMENTVIEW_SETTINGS_PANE_OPEN: "DocumentView Settings Pane Open",
  DOCUMENTVIEW_DOCUMENT_DETAILS_CLICK: "DocumentView Document Details Click",
  DOCUMENTVIEW_METAFIELDS_DETAILS_CLICK: "DocumentView Metafield Details Click",
  DOCUMENTVIEW_DOWNLOAD_DOC_CLICK: "DocumentView Download Document Click",
  DOCUMENTVIEW_PREVIEW_DOC_CLICK: "DocumentView Preview Document Click",
  DOCUMENTVIEW_DELETE_DOC_CLICK: "DocumentView Delete Document Click",
  DOCUMENTVIEW_ENABLE_METALENSE_CLICK: "DocumentView Enable Metalense Click",
  DOCUMENTVIEW_SAVEASTEMPLATE_CLICK: "DocumentView Save as Template Click",
  DOCUMENTVIEW_CLONE_DOC_CLICK: "DocumentView Clone Document Click",
  DOCUMENTVIEW_INVITE_USER_DROPDOWN_CLICK:
    "DocumentView Invite User Dropdown Click",
  DOCUMENTVIEW_REFER_SOMEONE_DROPDOWN_CLICK:
    "DocumentView Refer Someone Dropdown click",
  DOCUMENTVIEW_INVITE_USER_CLICK: "DocumentView Invite User click",
  DOCUMENTVIEW_REFER_SOMEONE_CLICK: "DocumentView Refer Someone click",
  DOCUMENTVIEW_UPGRADE_CLICK: "DocumentView Upgrade Click",
  DOCUMENTVIEW_GENERATE_MAGIC_LINK: "DocumentView Generate Magic Link",
  DOCUMENTVIEW_GENERATE_SNAP_LINK: "DocumentView Generate Snap Link",
  DOCUMENTVIEW_PUBLISH_FILLABLE_FORM: "DocumentView Publish Fillable Form",
  DOCUMENTVIEW_SEND_VIA_EMAIL_CLICK: "DocumentView Send via Email Click",
  DOCUMENTVIEW_SEND_FOR_PAYMENT_CLICK: "DocumentView Send for payment click",
  DOCUMENTVIEW_SEND_FOR_ACCEPTANCE_CLICK:
    "DocumentView Send for acceptance click",
  DOCUMENTVIEW_CHECK_AND_SEND_FOR_INTERNAL_APPROVALS:
    "DocumentView Check and send for internal approval",
  DOCUMENTVIEW_SEND_FOR_ESIGN_DROPDOWN_CLICK:
    "DocumentView Send for Esign Dropdown Click",
  DOCUMENTVIEW_SEND_FOR_ESIGN_CLICK: "DocumentView Send For Esign Click",
  DOCUMENTVIEW_EDIT_DOCUMENT_CLICK: "DocumentView Edit Document Click",
  DOCUMENTVIEW_METAMASK_BTN_CLICK: "DocumentView Metamask btn Click",
  DOCUMENTVIEW_ESIGN_SUMMARY_DOWNLOAD_CLICK:
    "DocumentView Esign Summary Download Click",
  SENDFORESIGNPOPUP_EDIT_DOC_CLICK: "SendForEsignPopup Edit Document Click",
  SENDFORESIGNPOPUP_CLOSE_CLICK: "SendForEsignPopup Close Click",
  SENDFORESIGNPOPUP_SEND_FOR_ESIGN_CLICK:
    "SendForEsignPopup Send For Esign Click",
  UPGRADEPLANPOPUP_UPGRADE_TO_PREMIUM_CLICK:
    "UpgradePlanPopup Upgrade to Premium Click",
  UPGRADEPLANPOPUP_VIEW_ALL_PLANS_CLICK:
    "UpgradePlanPopup View All Plans Click",
  TRANSACTIONPOPUP_VIEW_ALL_PLANS_CLICK:
    "TransactionPlanPopup View All Plans Click",
  TRANSACTIONPLANPOPUP_SUBSCRIBE_CLICK: "TransactionPlanPopup Subscribe Click",
  UPGRADEPLANPOPUP_CLOSE_CLICK: "UpgradePlanPopup Close Click",
  UPGRADEPLANPOPUP_CONTACTUS_CLICK: "UpgradePlanPopup Contact us Click",
  SEEALLPLANPOPUP_ANNUAL_TAB_CLICK: "SeeAllPlanPopup Annual Tab Click",
  SEEALLPLANPOPUP_MONTHLY_TAB_CLICK: "SeeAllPlanPopup Monthly Tab Click",
  SEEALLPLANPOPUP_SUBSCRIBE_CLICK: "SeeAllPlanPopup Subscribe Click",
  INVITEUSERPOPUP_COPY_LINK_CLICK: "InviteUserPopup Copy Link Click",
  INVITEUSERPOPUP_SEND_INVITE_CLICK: "InviteUserPopup Send Invite Click",
  INVITEUSERPOPUP_CANCEL_CLICK: "InviteUserPopup Cancel Click",
  INVITEUSERPOPUP_CLOSE_CLICK: "InviteUserPopup Close Click",
  PUBLISHTEMPLATEPOPUP_FORM_TABSWITCH_TEMPLATE_CLICK:
    "PublishTemplatePopup Form Tab switchTemplate Cick",
  PUBLISHTEMPLATEPOPUP_EDITABLE_TABSWITCH_TEMPLATE_CLICK:
    "PublishTemplatePopup Editable Tab switch Template Click",
  PUBLISHTEMPLATEPOPUP_PUBLISH_FORM_TEMPLATE_CLICK:
    "PublishTemplatePopup Publish Form Template Cick",
  PUBLISHTEMPLATEPOPUP_PUBLISH_EDITABLE_TEMPLATE_CLICK:
    "PublishTemplatePopup Publish Editable Template Click",
  PUBLISHTEMPLATEPOPUP_CLOSE_CLICK: "PublishTemplatePopup Close Click",
  BULKDOCUMENTCREATEPOPUP_CLOSE_CLICK: "BulkDocumentCreatePopup Close Click",
  BULKDOCUMENTCREATEPOPUP_CSV_SELECTED: "BulkDocumentCreatePopup CSV Selected",
  BULKDOCUMENTCREATEPOPUP_CREATE_DOCUMENTS_CLICK:
    "BulkDocumentCreatePopup Create Documents Click",
  SIGNINGCEREMONY_DOCDETAILS_CLICK: "SigningCeremony Document Details Click",
  SIGNINGCEREMONY_DOWNLOAD_DOC_CLICK: "SigningCeremony Download Document Click",
  SIGNINGCEREMONY_DECLINE_DOC_CLICK: "SigningCeremony Decline Document Click",
  SIGNINGCEREMONY_NEXT_CLICK: "SigningCeremony Next Click",
  SIGNINGCEREMONY_PREV_CLICK: "SigningCeremony Prev Click",
  SIGNINGCEREMONY_DOCDETAILSPOPUP_TNC_LINK_CLICK:
    "DocDetailsPopup TnC Link Click",
  SIGNINGCEREMONY_DOCDETAILSPOPUP_ESIGN_SUMMARY_DOWNLOAD_CLICK:
    "DocDetailsPopup Esign Summary Download Click",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_TEXT_TAB_CLICK:
    "ChooseSignPopup Text Tab Open",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_DRAW_TAB_CLICK:
    "ChooseSignPopup Draw Tab Open",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_DRAW_SIGN_CLICK:
    "ChooseSignPopup Draw Sign Complete",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_ADOPT_SIGNATURE_CLICK:
    "ChooseSignPopup Adopt Signature Click",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_UPLOAD_TAB_CLICK:
    "ChooseSignPopup Upload Tab Open",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_UPLOAD_SIGN_CLICK:
    "ChooseSignPopup Upload Sign Selected",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_METAMASK_TAB_CLICK:
    "ChooseSignPopup Metamask Tab Open",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_CLOSE_CLICK: "ChooseSignPopup Close Click",
  SIGNINGCEREMONY_CHOOSESIGNPOPUP_OPEN_CLICK: "ChooseSignPopup Open Click",
};
export default GTM_EVENTS;
